/**
 * Tool failures the clinician can act on in the transcript: connect an app,
 * or install/open desktop for a scheduled/event computer-use miss.
 * Everything else is agent-facing — the model already has the result.
 */

import type { DesktopRequiredScanItem } from '../../../contracts/desktop-required.types';
import { isRecord } from '../../../contracts/parse-utils';

import { readDesktopRequired } from './desktopRequired';

const isConnectRequired = (item: DesktopRequiredScanItem): boolean => {
  const data = item.result_provider_metadata?.data;
  return isRecord(data) && data.code === 'connect_required';
};

export const isClinicianActionableToolError = (
  item: DesktopRequiredScanItem
): boolean => {
  if (isConnectRequired(item)) return true;
  const desktop = readDesktopRequired(item);
  return desktop != null && desktop.trigger !== 'on_demand';
};
